import ApiService from "../api";

export default class CargaEntregaService extends ApiService {

    constructor() {
        super("/api/cargas");
    }

    importarExcel(data) {
        return this.post(`/upload`, data)
    }

    preVisualizarImportacao(data) {
        return this.post(`/upload/pre-visualizacao`, data)
    }

    vincularRotas(data) {
        const params = new URLSearchParams();
        params.append('ano', data.ano);
        params.append('mes', data.mes);
        return this.get(`/vincular-rotas?${params.toString()}`)
    }

    listar(filtros) {
        const params = new URLSearchParams();
        params.append('dataInicio', filtros.start);
        params.append('dataFim', filtros.end);
        params.append('filialId', filtros.filialId);

        return this.get(`?${params.toString()}`)
    }

    atualizarCarga(id, carga) {
        return this.put(`/${id}`, carga);
    }

    cadastrarCarga(carga) {
        return this.post(``, carga);
    }

    atualizarTransporte(id, transporte) {
        return this.patch(`/${id}/transporte`, { transporte });
    }

    // Altera somente o dia de operação da escala (dataOperacao no formato yyyy-MM-dd)
    atualizarDataOperacao(id, dataOperacao) {
        return this.patch(`/${id}/data-operacao`, { dataOperacao });
    }

    atualizarArea(id, area) {
        return this.patch(`/${id}/area`, { area });
    }

    atualizarVeiculo(id, veiculoId) {
        return this.patch(`/${id}/veiculo`, { veiculoId });
    }

    atualizarMotorista(id, motoristaId) {
        return this.patch(`/${id}/motorista`, { motoristaId });
    }

    atualizarAuxiliares(id, auxiliaresIds) {
        return this.patch(`/${id}/auxiliares`, { auxiliaresIds });
    }

    listarDiasPorPeriodo(filialId, dataInicio, dataFim) {
        return this.get(`/dias-operacao/periodo?filialId=${filialId}&inicio=${dataInicio}&fim=${dataFim}`);
    }

    listarPorPeriodo(funcionarioId, ano, mes, filialId) {
        const params = new URLSearchParams();
        params.append('ano', ano);
        params.append('mes', mes);
        if (funcionarioId) params.append('funcionarioId', funcionarioId);
        if (filialId) params.append('filialId', filialId);

        return this.get(`/por-periodo?${params.toString()}`);
    }

    excluirCarga(id) {
        return this.delete(`/${id}`)
    }

    excluirPorDia(data) {
        const params = new URLSearchParams();
        params.append('filialId', data.filialId);
        params.append('data', data.data);
        return this.delete(`/excluir-por-dia?${params.toString()}`)
    }

    buscarImportacao(filtros) {
        const params = new URLSearchParams();
        params.append('dataOperacao', filtros.dataOperacao);
        params.append('filialId', filtros.filialId);

        return this.get(`/busca-importacao?${params.toString()}`)
    }

    exportarPlanilha(filtros) {
        const params = new URLSearchParams();
        params.append('dataInicio', filtros.start);
        params.append('dataFim', filtros.end);
        params.append('filialId', filtros.filialId);
        params.append('modelo', filtros.modelo || 'SIMPLES');

        return this.fileDownload(`/exportar?${params.toString()}`)
    }

    validaMotorista(filtros) {
        const params = new URLSearchParams();
        params.append('dataOperacao', filtros.dataOperacao);
        params.append('motoristaId', filtros.motoristaId);
        if (filtros.cargaId) params.append('cargaId', filtros.cargaId);

        return this.get(`/valida-motorista?${params.toString()}`)
    }

    validaVeiculo(filtros) {
        const params = new URLSearchParams();
        params.append('dataOperacao', filtros.dataOperacao);
        params.append('veiculoId', filtros.veiculoId);
        if (filtros.cargaId) params.append('cargaId', filtros.cargaId);

        return this.get(`/valida-veiculo?${params.toString()}`)
    }

    validadAuxiliar(filtros) {
        const params = new URLSearchParams();
        params.append('dataOperacao', filtros.dataOperacao);
        params.append('auxiliarId', filtros.auxiliarId);
        if (filtros.cargaId) params.append('cargaId', filtros.cargaId);

        return this.get(`/valida-auxiliar?${params.toString()}`)
    }
}
